const betaDark = {
  id: 'betaDark',
  displayName: 'Beta Dark',
  enabled: false,
  graph: {
    writeSample: '#F5A623', writeTrend: 'rgba(245, 166, 35, 0.78)',
    writeMax: '#FFD080', writeMin: '#C0623A', writeLatency: '#F5A623',
    readSample: '#4FC3F7', readTrend: 'rgba(79, 195, 247, 0.78)',
    readMax: '#81D4FA', readMin: '#0288D1', readLatency: '#4FC3F7',
  },
  canvas: {
    chartBg: '#1C1C1C', gridColor: '#3A3A3A', textColor: '#ADB5BD',
  },
};
export default betaDark;
